/// <reference lib="dom" />
/**
 * Thrown by same-origin `/api/*` clients when the server rejects a request
 * with `403 csrf_missing` or `403 csrf_invalid`. The client has already
 * called `csrfManager.invalidate()` by the time this is thrown. Consumers
 * should either catch + handle (e.g. prompt re-login) or let it bubble to
 * the App's global `unhandledrejection` handler which redirects to `/login`.
 */
export class CsrfInvalidError extends Error {
    csrfInvalid = true;
    constructor(message = 'CSRF token invalid — please log in again.') {
        super(message);
        this.name = 'CsrfInvalidError';
    }
}
/** Type guard for catch blocks and unhandledrejection handlers. */
export function isCsrfInvalidError(err) {
    return (err instanceof Error &&
        err.csrfInvalid === true &&
        err.name === 'CsrfInvalidError');
}
export function createCsrfManager() {
    let current = null;
    return {
        get() {
            return current;
        },
        setFromResponse(response) {
            const header = response.headers.get('X-CSRF-Token');
            if (header && header.length > 0) {
                current = header;
            }
        },
        invalidate() {
            current = null;
        },
    };
}
//# sourceMappingURL=csrf-manager.js.map